/**
 * @ngdoc service
 * @name CTChannelRepository
 *
 * @description
 * Creates and holds Channels based on module-type and module-identifier.
 */
const moduleName = 'cambuildr.service.prefill';

angular.module(moduleName, []).service('Prefill', ["$parse", function ($parse) {
    const _service = this;

    const _getParam = (function () {
        const query_array = window.location.search
            .replace(/\??/, '')
            .split('&')
            .map((part) => part.split('='))
            .map((part) => ({[part[0]]: decodeURIComponent(part[1])}));

        const query = Object.assign({}, ...query_array);

        return (param_name) => query[param_name];
    }());

    /**
     * Validate the given property_definition
     * @param {string|object|*} property_definition
     * @return {boolean}
     */
    function validate(property_definition) {
        if (typeof property_definition === "string") {
            return true
        }

        if (property_definition.hasOwnProperty('prop') && property_definition.hasOwnProperty('param')) {
            return true
        }

        throw new Error("PrefillService was given an invalid property_definition");
    }


    /**
     * Prefill a given object with given parameters
     *
     * You can also define nested properties by separating them with a dot.
     * Example: ['title', 'person.name', 'person.address.zip_code']
     *
     * Properties will automatically be mapped to to their associated query
     * parameters. The last part of the property name will be the parameter
     * name. So property `title` will get `title` and `person.address.zip_code`
     * will be `zip_code`.
     * In some cases you may want to use custom mapping to avoid conflicts.
     * Therefore you can pass an object with the properties `prop` and `param`
     * instead of a string.
     *
     * @param {object} target The object to fill the data in
     * @param {Array} values An array of properties that should be prefilled.
     */
    _service.prefill = (target, values) => {
        values
            .map((prop) => {
                validate(prop);

                if (typeof prop === "string") {
                    let param = prop.split('.').pop();
                    return {param, prop};
                } else {
                    return prop;
                }
            })
            .forEach((mapping) => {
                let value = _getParam(mapping.param);
                let setter = $parse(mapping.prop).assign;

                // Special Treatment for zip code to let angular validate the input
                if (mapping.param == "zip_code") {
                    value = parseInt(value);
                }

                setter(target, value)
            })
    };
}]);

module.exports = moduleName;
